// Loader.js
import React from "react";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { componentKey } from "./LoaderSlice";
import { RotatingLines } from "react-loader-spinner";

const Loader = () => {
  const { isLoading } = useSelector((state: any) => state[componentKey]);

  if (!isLoading) {
    return null; // Do not render anything if not loading
  }

  const styles: any = {
    loader: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      // backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 100000, // Make sure the loader appears on top of everything
      background: "transparent",
    },
  };

  return (
    <div style={styles.loader}>
      {/* <CircularProgress /> */}
      <RotatingLines
        visible={true}
        width="60"
        strokeWidth="5"
        animationDuration="0.75"
        ariaLabel="rotating-lines-loading"
        strokeColor="#005596"
      />
    </div>
  );
};

export default Loader;
